/**
 * @generated SignedSource<<cf88afee2b29d20646647a7dc63eb98d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutSteps_transaction$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutDeliveryStep_transaction" | "CheckoutNavigation_transaction" | "CheckoutPaymentStepSelector_transaction" | "CheckoutPaymentStep_transaction" | "CheckoutProgressReview_transaction" | "CheckoutReviewStep_transaction" | "CheckoutShippingStep_transaction">;
  readonly " $fragmentType": "CheckoutSteps_transaction";
};
export type CheckoutSteps_transaction$key = {
  readonly " $data"?: CheckoutSteps_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSteps_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutSteps_transaction",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutShippingStep_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutReviewStep_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutDeliveryStep_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutNavigation_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutProgressReview_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutPaymentStep_transaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutPaymentStepSelector_transaction"
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "1602d1079d876813e84963dfb5aa34ab";

export default node;
